import { render, staticRenderFns } from "./TimeConsumptionStatistics.vue?vue&type=template&id=43f24015&scoped=true"
import script from "./TimeConsumptionStatistics.vue?vue&type=script&lang=ts"
export * from "./TimeConsumptionStatistics.vue?vue&type=script&lang=ts"
import style0 from "./TimeConsumptionStatistics.vue?vue&type=style&index=0&id=43f24015&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f24015",
  null
  
)

export default component.exports